module.exports = __webpack_public_path__ + "static/img/callmeicon.72ed7c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/callmeicon.png
// module id = uYbx
// module chunks = 1